
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-025afb5d&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ReviewDirect.vue")
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-025afb5d!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./ReviewDirect.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReviewDirect.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-025afb5d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReviewDirect.vue"),
  /* scopeId */
  "data-v-025afb5d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/review/ReviewDirect.vue
// module id = 313
// module chunks = 1